import CryptoJS from "crypto-js";
import { ENCRYPT_LOCAL_STORAGE, ENCRYPTION_KEY } from "./constants";

const generateIV = () => {
    // Generate 16 random bytes
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);
    return CryptoJS.lib.WordArray.create(array);
};

const IV_SEPARATOR = "::§§::";

// AES encryption
const encrypt = (data) => {
    if (!data) return null;
    if (!ENCRYPT_LOCAL_STORAGE) return JSON.stringify(data);

    try {
        const jsonData = JSON.stringify(data);
        const iv = generateIV();
        const ivHex = CryptoJS.enc.Hex.stringify(iv);
        
        const encrypted = CryptoJS.AES.encrypt(jsonData, CryptoJS.enc.Hex.parse(ENCRYPTION_KEY), {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }).toString();

        return `${ivHex}${IV_SEPARATOR}${encrypted}`;
    } catch (error) {
        console.error("Encryption error:", error);
        return null;
    }
};

const decrypt = (encrypted) => {
    if (!encrypted) return null;
    if (!ENCRYPT_LOCAL_STORAGE) {
        try {
            return JSON.parse(encrypted);
        } catch (e) {
            return encrypted;
        }
    }

    try {
        const [ivHex, encryptedData] = encrypted.split(IV_SEPARATOR);
        const iv = CryptoJS.enc.Hex.parse(ivHex);
        
        const decrypted = CryptoJS.AES.decrypt(encryptedData, CryptoJS.enc.Hex.parse(ENCRYPTION_KEY), {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        if (!decryptedText) {
            throw new Error("Decryption failed; output is empty");
        }

        return JSON.parse(decryptedText);
    } catch (error) {
        console.error("Decryption error:", error.message);
        return null;
    }
};

export { encrypt, decrypt };
